import { render, staticRenderFns } from "./videoRecord.vue?vue&type=template&id=50f4375c&scoped=true&"
import script from "./videoRecord.vue?vue&type=script&lang=js&"
export * from "./videoRecord.vue?vue&type=script&lang=js&"
import style0 from "./videoRecord.vue?vue&type=style&index=0&id=50f4375c&scoped=true&lang=css&"
import style1 from "./videoRecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f4375c",
  null
  
)

export default component.exports